import { BASE_PALETTES, type BaseThemePalette, type ThemeName } from '@bn-games/theming';

export type { ThemeName };

export interface Theme extends BaseThemePalette {
  readonly darkSquareBase: string;
  readonly darkSquareTip: string;
  readonly lightSquareBase: string;
  readonly lightSquareTip: string;
  /** Tint over the last move's from/to squares. */
  readonly lastMoveTint: string;
}

// The square gradients are checkers' own, theme for theme, so the two board
// games are one board. Chess adds only the last-move tint.
export const THEMES: Record<ThemeName, Theme> = {
  mahogany: {
    ...BASE_PALETTES.mahogany,
    darkSquareBase: '#3d1808',
    darkSquareTip: '#1f0c06',
    lightSquareBase: '#d9a062',
    lightSquareTip: '#b07a40',
    lastMoveTint: 'rgba(244, 216, 148, 0.42)',
  },
  persian: {
    ...BASE_PALETTES.persian,
    darkSquareBase: '#2a1808',
    darkSquareTip: '#0b2a36',
    lightSquareBase: '#d4a55a',
    lightSquareTip: '#a87c38',
    lastMoveTint: 'rgba(88, 196, 204, 0.38)',
  },
  deco: {
    ...BASE_PALETTES.deco,
    darkSquareBase: '#0a0908',
    darkSquareTip: '#040404',
    lightSquareBase: '#d4b06c',
    lightSquareTip: '#a88848',
    lastMoveTint: 'rgba(240, 216, 152, 0.38)',
  },
  monte: {
    ...BASE_PALETTES.monte,
    darkSquareBase: '#1a0e04',
    darkSquareTip: '#06241a',
    lightSquareBase: '#d4b06c',
    lightSquareTip: '#a88848',
    lastMoveTint: 'rgba(240, 216, 120, 0.4)',
  },
};
